import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Locations/hooks/useLocationCheckpointScan.ts
function useLocationCheckpointScan(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Locations.GetLocationCheckpointScanDetail.v2, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useLocationCheckpointScan };

//# sourceMappingURL=useLocationCheckpointScan.js.map